// This file was automatically generated from the Assemblyscript transform: export-all.ts
// during the Assemblyscript compilation. Use `npm run asbuild` to regenerate.
export const envTypes = {
  gen_daverb_nearestPowerOfTwo: '(i32) i32',
  index_getRingPos: '() i32',
  engine_get_ratesSamples: '(i32) i32',
  engine_get_rates: '(i32) i32',
  engine_set_audioRate: '(i32 i32) void',
  engine_set_controlRate: '(i32 i32) void',
  engine_Clock_set_frame: '(i32 i32) void',
  engine_Clock_constructor: '(i32) i32',
  engine_set_clock: '(i32 i32) void',
  engine_set_rates: '(i32 i32) void',
  engine_set_ratesSamples: '(i32 i32) void',
  wavetable_set_length: '(i32 i32) void',
  wavetable_set_mask: '(i32 i32) void',
  wavetable_set_phases: '(i32 i32) void',
  wavetable_set_sine: '(i32 i32) void',
  wavetable_set_exp: '(i32 i32) void',
  wavetable_set_saw: '(i32 i32) void',
  wavetable_set_ramp: '(i32 i32) void',
  wavetable_set_tri: '(i32 i32) void',
  wavetable_set_sqr: '(i32 i32) void',
  wavetable_set_noise: '(i32 i32) void',
  wavetable_get_size: '(i32) i32',
  wavetable_get_length: '(i32) i32',
  wavetable_get_phases: '(i32) i32',
  wavetable_get_sine: '(i32) i32',
  util_phaseToRadians: '(i32) f64',
  wavetable_fill: '(i32 i32 i32 i32) void',
  wavetable_get_exp: '(i32) i32',
  wavetable_exp: '(f64) f64',
  wavetable_get_saw: '(i32) i32',
  wave_saw: '(f64) f64',
  wavetable_get_ramp: '(i32) i32',
  wave_ramp: '(f64) f64',
  wavetable_get_tri: '(i32) i32',
  wave_tri: '(f64) f64',
  wavetable_get_sqr: '(i32) i32',
  wave_sqr: '(f64) f64',
  wavetable_get_noise: '(i32) i32',
  wave_rnd: '(f64) f64',
  wave_noise: '(f64) f64',
  wavetable_set_size: '(i32 i32) void',
  wavetable_constructor: '(i32 i32) i32',
  engine_set_wavetable: '(i32 i32) void',
  engine_constructor: '(i32 i32 i32) i32',
  engine_createBlockInternal: '(i32) i32',
  engine_createBlock: '(i32 i32) i32',
  engine_get_clock: '(i32) i32',
  engine_Clock_get_frame: '(i32) i32',
  gen_gen_set_engine: '(i32 i32) void',
  gen_gen_set_rateKind: '(i32 i32) void',
  gen_gen_set_gain: '(i32 f32) void',
  gen_gen_constructor: '(i32 i32 i32) i32',
  gen_zero_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_zero_Zero_: '() i32',
  gen_osc_set_hz: '(i32 f32) void',
  gen_osc_set_offset: '(i32 f32) void',
  gen_osc_set_phase: '(i32 i32) void',
  gen_osc_set_step: '(i32 i32) void',
  gen_osc_set_sample: '(i32 f32) void',
  gen_osc_set_trig: '(i32 f32) void',
  gen_osc_set_hasTrig: '(i32 i32) void',
  gen_osc_set_lastTrig: '(i32 f32) void',
  gen_osc_constructor: '(i32 i32 i32) i32',
  gen_sin_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_sin_Sin_: '() i32',
  gen_exp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_exp_Exp_: '() i32',
  gen_saw_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_saw_Saw_: '() i32',
  gen_ramp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_ramp_Ramp_: '() i32',
  gen_sqr_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_sqr_Sqr_: '() i32',
  gen_tri_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_tri_Tri_: '() i32',
  gen_noise_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_noise_Noise_: '() i32',
  gen_dc_set_ceil: '(i32 f32) void',
  gen_dc_set_in: '(i32 i32) void',
  gen_dc_set_sample: '(i32 f32) void',
  gen_dc_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_dc_Dc_: '() i32',
  gen_delay_set_ms: '(i32 f32) void',
  gen_delay_set_fb: '(i32 f32) void',
  gen_delay_set_in: '(i32 i32) void',
  gen_delay_set_floats: '(i32 i32) void',
  gen_delay_set_mask: '(i32 i32) void',
  gen_delay_set_index: '(i32 i32) void',
  gen_delay_set_stepf: '(i32 f32) void',
  gen_delay_set_targetf: '(i32 f32) void',
  gen_delay_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_delay_Delay_: '() i32',
  gen_tap_set_ms: '(i32 f32) void',
  gen_tap_set_in: '(i32 i32) void',
  gen_tap_set_floats: '(i32 i32) void',
  gen_tap_set_mask: '(i32 i32) void',
  gen_tap_set_index: '(i32 i32) void',
  gen_tap_set_stepf: '(i32 f32) void',
  gen_tap_set_targetf: '(i32 f32) void',
  gen_tap_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_tap_Tap_: '() i32',
  gen_lp_set_cut: '(i32 f32) void',
  gen_lp_set_in: '(i32 i32) void',
  gen_lp_set_alpha: '(i32 f32) void',
  gen_lp_set_beta: '(i32 f32) void',
  gen_lp_set_sample: '(i32 f32) void',
  gen_lp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_lp_Lp_: '() i32',
  gen_rate_set_samples: '(i32 f32) void',
  gen_rate_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_rate_Rate_: '() i32',
  gen_biquad_set_in: '(i32 i32) void',
  gen_biquad_set_x1: '(i32 f64) void',
  gen_biquad_set_x2: '(i32 f64) void',
  gen_biquad_set_y1: '(i32 f64) void',
  gen_biquad_set_y2: '(i32 f64) void',
  gen_biquad_set_a0: '(i32 f64) void',
  gen_biquad_set_a1: '(i32 f64) void',
  gen_biquad_set_a2: '(i32 f64) void',
  gen_biquad_set_b0: '(i32 f64) void',
  gen_biquad_set_b1: '(i32 f64) void',
  gen_biquad_set_b2: '(i32 f64) void',
  gen_biquad_set_params_freq: '(i32 i32) void',
  gen_biquad_set_params_Q: '(i32 i32) void',
  gen_biquad_set_params_gain: '(i32 i32) void',
  gen_biquad_constructor: '(i32 i32 i32) i32',
  gen_blp_set_cut: '(i32 f32) void',
  gen_blp_set_q: '(i32 f32) void',
  gen_blp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_blp_Blp_: '() i32',
  gen_bhp_set_cut: '(i32 f32) void',
  gen_bhp_set_q: '(i32 f32) void',
  gen_bhp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bhp_Bhp_: '() i32',
  gen_bbp_set_cut: '(i32 f32) void',
  gen_bbp_set_q: '(i32 f32) void',
  gen_bbp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bbp_Bbp_: '() i32',
  gen_bno_set_cut: '(i32 f32) void',
  gen_bno_set_q: '(i32 f32) void',
  gen_bno_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bno_Bno_: '() i32',
  gen_bpk_set_cut: '(i32 f32) void',
  gen_bpk_set_q: '(i32 f32) void',
  gen_bpk_set_amt: '(i32 f32) void',
  gen_bpk_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bpk_Bpk_: '() i32',
  gen_bap_set_cut: '(i32 f32) void',
  gen_bap_set_q: '(i32 f32) void',
  gen_bap_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bap_Bap_: '() i32',
  gen_bls_set_cut: '(i32 f32) void',
  gen_bls_set_q: '(i32 f32) void',
  gen_bls_set_amt: '(i32 f32) void',
  gen_bls_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bls_Bls_: '() i32',
  gen_bhs_set_cut: '(i32 f32) void',
  gen_bhs_set_q: '(i32 f32) void',
  gen_bhs_set_amt: '(i32 f32) void',
  gen_bhs_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_bhs_Bhs_: '() i32',
  gen_svf_set_in: '(i32 i32) void',
  gen_svf_set_c1: '(i32 f64) void',
  gen_svf_set_c2: '(i32 f64) void',
  gen_svf_set_a1: '(i32 f64) void',
  gen_svf_set_a2: '(i32 f64) void',
  gen_svf_set_a3: '(i32 f64) void',
  gen_svf_set_v0: '(i32 f64) void',
  gen_svf_set_v1: '(i32 f64) void',
  gen_svf_set_v2: '(i32 f64) void',
  gen_svf_set_v3: '(i32 f64) void',
  gen_svf_set_k: '(i32 f64) void',
  gen_svf_set_params_freq: '(i32 i32) void',
  gen_svf_set_params_Q: '(i32 i32) void',
  gen_svf_constructor: '(i32 i32 i32) i32',
  gen_slp_set_cut: '(i32 f32) void',
  gen_slp_set_q: '(i32 f32) void',
  gen_slp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_slp_Slp_: '() i32',
  gen_shp_set_cut: '(i32 f32) void',
  gen_shp_set_q: '(i32 f32) void',
  gen_shp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_shp_Shp_: '() i32',
  gen_sbp_set_cut: '(i32 f32) void',
  gen_sbp_set_q: '(i32 f32) void',
  gen_sbp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_sbp_Sbp_: '() i32',
  gen_sap_set_cut: '(i32 f32) void',
  gen_sap_set_q: '(i32 f32) void',
  gen_sap_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_sap_Sap_: '() i32',
  gen_sno_set_cut: '(i32 f32) void',
  gen_sno_set_q: '(i32 f32) void',
  gen_sno_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_sno_Sno_: '() i32',
  gen_spk_set_cut: '(i32 f32) void',
  gen_spk_set_q: '(i32 f32) void',
  gen_spk_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_spk_Spk_: '() i32',
  gen_moog_set_in: '(i32 i32) void',
  gen_moog_set__m_azt1: '(i32 f32) void',
  gen_moog_set__m_azt2: '(i32 f32) void',
  gen_moog_set__m_azt3: '(i32 f32) void',
  gen_moog_set__m_azt4: '(i32 f32) void',
  gen_moog_set__m_az5: '(i32 f32) void',
  gen_moog_set__m_amf: '(i32 f32) void',
  gen_moog_set__v2: '(i32 f32) void',
  gen_moog_set__x1: '(i32 f32) void',
  gen_moog_set__az3: '(i32 f32) void',
  gen_moog_set__az4: '(i32 f32) void',
  gen_moog_set__amf: '(i32 f32) void',
  gen_moog_set__kVt: '(i32 f32) void',
  gen_moog_set__m_kacr: '(i32 f32) void',
  gen_moog_set__m_k2vg: '(i32 f32) void',
  gen_moog_set__m_postGain: '(i32 f32) void',
  gen_moog_set_params_freq: '(i32 i32) void',
  gen_moog_set_params_Q: '(i32 i32) void',
  gen_moog_constructor: '(i32 i32 i32) i32',
  gen_mlp_set_cut: '(i32 f32) void',
  gen_mlp_set_q: '(i32 f32) void',
  gen_mlp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_mlp_Mlp_: '() i32',
  gen_mhp_set_cut: '(i32 f32) void',
  gen_mhp_set_q: '(i32 f32) void',
  gen_mhp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_mhp_Mhp_: '() i32',
  gen_daverb_set_in: '(i32 i32) void',
  gen_daverb_set_pd: '(i32 f32) void',
  gen_daverb_set_bw: '(i32 f32) void',
  gen_daverb_set_fi: '(i32 f32) void',
  gen_daverb_set_si: '(i32 f32) void',
  gen_daverb_set_dc: '(i32 f32) void',
  gen_daverb_set_ft: '(i32 f32) void',
  gen_daverb_set_st: '(i32 f32) void',
  gen_daverb_set_dp: '(i32 f32) void',
  gen_daverb_set_ex: '(i32 f32) void',
  gen_daverb_set_ed: '(i32 f32) void',
  gen_daverb_set_params_pd: '(i32 i32) void',
  gen_daverb_set_params_bw: '(i32 i32) void',
  gen_daverb_set_params_fi: '(i32 i32) void',
  gen_daverb_set_params_si: '(i32 i32) void',
  gen_daverb_set_params_dc: '(i32 i32) void',
  gen_daverb_set_params_ft: '(i32 i32) void',
  gen_daverb_set_params_st: '(i32 i32) void',
  gen_daverb_set_params_dp: '(i32 i32) void',
  gen_daverb_set_params_ex: '(i32 i32) void',
  gen_daverb_set_params_ed: '(i32 i32) void',
  gen_daverb_set_dpn: '(i32 f32) void',
  gen_daverb_set_exn: '(i32 f32) void',
  gen_daverb_set_edn: '(i32 f32) void',
  gen_daverb_set_pdn: '(i32 f32) void',
  gen_daverb_set_predelay: '(i32 i32) void',
  gen_daverb_set_d0: '(i32 i32) void',
  gen_daverb_set_d1: '(i32 i32) void',
  gen_daverb_set_d2: '(i32 i32) void',
  gen_daverb_set_d3: '(i32 i32) void',
  gen_daverb_set_d4: '(i32 i32) void',
  gen_daverb_set_d5: '(i32 i32) void',
  gen_daverb_set_d6: '(i32 i32) void',
  gen_daverb_set_d7: '(i32 i32) void',
  gen_daverb_set_d8: '(i32 i32) void',
  gen_daverb_set_d9: '(i32 i32) void',
  gen_daverb_set_d10: '(i32 i32) void',
  gen_daverb_set_d11: '(i32 i32) void',
  gen_daverb_set_index: '(i32 i32) void',
  gen_daverb_set_mask: '(i32 i32) void',
  gen_daverb_set_lp1: '(i32 f32) void',
  gen_daverb_set_lp2: '(i32 f32) void',
  gen_daverb_set_lp3: '(i32 f32) void',
  gen_daverb_set_excPhase: '(i32 i32) void',
  gen_daverb_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_daverb_Daverb_: '() i32',
  gen_tanh_set_gain: '(i32 f32) void',
  gen_tanh_set_gainv: '(i32 v128) void',
  gen_tanh_set_in: '(i32 i32) void',
  gen_tanh_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_tanh_Tanh_: '() i32',
  gen_diode_set_cut: '(i32 f32) void',
  gen_diode_set_hpf: '(i32 f32) void',
  gen_diode_set_sat: '(i32 f32) void',
  gen_diode_set_q: '(i32 f32) void',
  gen_diode_set_in: '(i32 i32) void',
  gen_diode_set_z0: '(i32 f32) void',
  gen_diode_set_z1: '(i32 f32) void',
  gen_diode_set_z2: '(i32 f32) void',
  gen_diode_set_z3: '(i32 f32) void',
  gen_diode_set_z4: '(i32 f32) void',
  gen_diode_set_A: '(i32 f32) void',
  gen_diode_set_a: '(i32 f32) void',
  gen_diode_set_a2: '(i32 f32) void',
  gen_diode_set_b: '(i32 f32) void',
  gen_diode_set_b2: '(i32 f32) void',
  gen_diode_set_c: '(i32 f32) void',
  gen_diode_set_g: '(i32 f32) void',
  gen_diode_set_g0: '(i32 f32) void',
  gen_diode_set_ah: '(i32 f32) void',
  gen_diode_set_bh: '(i32 f32) void',
  gen_diode_set_ainv: '(i32 f32) void',
  gen_diode_set_k: '(i32 f32) void',
  gen_diode_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_diode_Diode_: '() i32',
  gen_dclip_set_in: '(i32 i32) void',
  gen_dclip_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_dclip_Dclip_: '() i32',
  gen_dcliplin_set_threshold: '(i32 f32) void',
  gen_dcliplin_set_factor: '(i32 f32) void',
  gen_dcliplin_set_in: '(i32 i32) void',
  gen_dcliplin_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_dcliplin_Dcliplin_: '() i32',
  gen_dclipexp_set_factor: '(i32 f32) void',
  gen_dclipexp_set_in: '(i32 i32) void',
  gen_dclipexp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_dclipexp_Dclipexp_: '() i32',
  gen_clamp_set_min: '(i32 f32) void',
  gen_clamp_set_max: '(i32 f32) void',
  gen_clamp_set_in: '(i32 i32) void',
  gen_clamp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_clamp_Clamp_: '() i32',
  gen_clip_set_threshold: '(i32 f32) void',
  gen_clip_set_in: '(i32 i32) void',
  gen_clip_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_clip_Clip_: '() i32',
  gen_comp_set_threshold: '(i32 f32) void',
  gen_comp_set_ratio: '(i32 f32) void',
  gen_comp_set_attack: '(i32 f32) void',
  gen_comp_set_release: '(i32 f32) void',
  gen_comp_set_in: '(i32 i32) void',
  gen_comp_set_sidechain: '(i32 i32) void',
  gen_comp_set_prevLevel: '(i32 f32) void',
  gen_comp_set_gainReduction: '(i32 f32) void',
  gen_comp_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_comp_Comp_: '() i32',
  gen_sample_set_offset: '(i32 f32) void',
  gen_sample_set_floats: '(i32 i32) void',
  gen_sample_set_mask: '(i32 i32) void',
  gen_sample_set_phase: '(i32 i32) void',
  gen_sample_set_step: '(i32 i32) void',
  gen_sample_set_offsetCurrent: '(i32 f64) void',
  gen_sample_set_offsetTarget: '(i32 f64) void',
  gen_sample_set_trig: '(i32 f32) void',
  gen_sample_set_hasTrig: '(i32 i32) void',
  gen_sample_set_lastTrig: '(i32 f32) void',
  gen_sample_constructor: '(i32 i32 i32) i32',
  gen_freesound_set_id: '(i32 f32) void',
  gen_freesound_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_freesound_Freesound_: '() i32',
  gen_freesound_get_id: '(i32) f32',
  env_logf: '(f32) void',
  gen_say_set_text: '(i32 f32) void',
  gen_say_constructor: '(i32 i32 i32) i32',
  util_getObjectSize__gen_say_Say_: '() i32',
  gen_gen_update: '(i32) void',
  gen_gen_audio: '(i32 i32 i32 i32) void',
  pow_audio_scalar: '(i32 f32 i32 i32 i32) void',
  pow_scalar_audio: '(f32 i32 i32 i32 i32) void',
  pow_scalar_scalar: '(f32 f32) f32',
  mul_audio_scalar: '(i32 f32 i32 i32 i32) void',
  mul_audio_audio: '(i32 i32 i32 i32 i32) void',
  div_audio_scalar: '(i32 f32 i32 i32 i32) void',
  div_scalar_audio: '(f32 i32 i32 i32 i32) void',
  add_audio_scalar: '(i32 f32 i32 i32 i32) void',
  add_audio_audio: '(i32 i32 i32 i32 i32) void',
  sub_audio_scalar: '(i32 f32 i32 i32 i32) void',
  sub_audio_audio: '(i32 i32 i32 i32 i32) void',
  not_audio: '(i32 i32 i32 i32) void',
  to_audio_scalar: '(f32 i32 i32 i32) void',
  fade_fadeIn: '(i32 i32 i32 i32) void',
  fade_fadeOut: '(i32 i32 i32 i32) void',
  join_join21g: '(i32 i32 i32 i32 i32 f32 f32) void',
  join_join21: '(i32 i32 i32 i32 i32) void',
  dc_bias_dcBias: '(i32 i32 i32) void',
  rms_: '(i32 i32 i32) f32',
  index_preventTreeShaking: '(i32) void',
  bench_audio_benchAudio: '(i32 i32 i32) void',
  gen_gen_get_gain: '(i32) f32',
  bench_audio_benchAudioGain: '(i32 i32 i32) void',
  bench_audio_benchAudioTwo: '(i32 i32 i32 i32 i32 i32) void',
  gen_bap_get_cut: '(i32) f32',
  gen_bap_get_q: '(i32) f32',
  gen_biquad_get_params_freq: '(i32) i32',
  gen_biquad_clamp: '(f32 f32 f32 f32) f32',
  gen_biquad_paramClamp: '(i32 f32) f32',
  gen_biquad_get_params_Q: '(i32) i32',
  gen_gen_get_engine: '(i32) i32',
  engine_get_audioRate: '(i32) i32',
  gen_biquad_get_a0: '(i32) f64',
  gen_biquad_get_b0: '(i32) f64',
  gen_biquad_get_b1: '(i32) f64',
  gen_biquad_get_b2: '(i32) f64',
  gen_biquad_get_a1: '(i32) f64',
  gen_biquad_get_a2: '(i32) f64',
  gen_bap_update: '(i32) void',
  gen_bbp_get_cut: '(i32) f32',
  gen_bbp_get_q: '(i32) f32',
  gen_bbp_update: '(i32) void',
  gen_bhp_get_cut: '(i32) f32',
  gen_bhp_get_q: '(i32) f32',
  gen_bhp_update: '(i32) void',
  gen_bhs_get_cut: '(i32) f32',
  gen_bhs_get_q: '(i32) f32',
  gen_bhs_get_amt: '(i32) f32',
  gen_biquad_get_params_gain: '(i32) i32',
  gen_bhs_update: '(i32) void',
  gen_blp_get_cut: '(i32) f32',
  gen_blp_get_q: '(i32) f32',
  gen_blp_update: '(i32) void',
  gen_bls_get_cut: '(i32) f32',
  gen_bls_get_q: '(i32) f32',
  gen_bls_get_amt: '(i32) f32',
  gen_bls_update: '(i32) void',
  gen_bno_get_cut: '(i32) f32',
  gen_bno_get_q: '(i32) f32',
  gen_bno_update: '(i32) void',
  gen_bpk_get_cut: '(i32) f32',
  gen_bpk_get_q: '(i32) f32',
  gen_bpk_get_amt: '(i32) f32',
  gen_bpk_update: '(i32) void',
  gen_comp_update: '(i32) void',
  gen_daverb_get_dp: '(i32) f32',
  gen_daverb_get_ex: '(i32) f32',
  gen_daverb_get_ed: '(i32) f32',
  gen_daverb_get_pd: '(i32) f32',
  gen_daverb_update: '(i32) void',
  gen_delay_get_ms: '(i32) f32',
  gen_gen_get_rateKind: '(i32) i32',
  gen_gen_get_rate: '(i32) i32',
  gen_delay_get_stepf: '(i32) f32',
  gen_delay_get_targetf: '(i32) f32',
  gen_delay_update: '(i32) void',
  gen_diode_get_hpf: '(i32) f32',
  gen_diode_clamp: '(f32 f32 f32) f32',
  gen_diode_get_q: '(i32) f32',
  gen_diode_get_k: '(i32) f32',
  gen_diode_get_cut: '(i32) f32',
  gen_diode_update: '(i32) void',
  gen_lp_get_cut: '(i32) f32',
  gen_lp_update: '(i32) void',
  gen_mhp_get_cut: '(i32) f32',
  gen_mhp_get_q: '(i32) f32',
  gen_moog_get_params_freq: '(i32) i32',
  gen_moog_clamp: '(f32 f32 f32 f32) f32',
  gen_moog_paramClamp: '(i32 f32) f32',
  gen_moog_get_params_Q: '(i32) i32',
  gen_moog_get__kVt: '(i32) f32',
  gen_moog_get__v2: '(i32) f32',
  gen_mhp_update: '(i32) void',
  gen_mlp_get_cut: '(i32) f32',
  gen_mlp_get_q: '(i32) f32',
  gen_mlp_update: '(i32) void',
  gen_rate_get_samples: '(i32) f32',
  gen_rate_update: '(i32) void',
  gen_sap_get_cut: '(i32) f32',
  gen_sap_get_q: '(i32) f32',
  gen_svf_get_params_freq: '(i32) i32',
  gen_svf_clamp: '(f32 f32 f32 f32) f32',
  gen_svf_paramClamp: '(i32 f32) f32',
  gen_svf_get_params_Q: '(i32) i32',
  gen_svf_get_k: '(i32) f64',
  gen_svf_get_a1: '(i32) f64',
  gen_svf_get_a2: '(i32) f64',
  gen_sap_update: '(i32) void',
  gen_sbp_get_cut: '(i32) f32',
  gen_sbp_get_q: '(i32) f32',
  gen_sbp_update: '(i32) void',
  gen_shp_get_cut: '(i32) f32',
  gen_shp_get_q: '(i32) f32',
  gen_shp_update: '(i32) void',
  gen_slp_get_cut: '(i32) f32',
  gen_slp_get_q: '(i32) f32',
  gen_slp_update: '(i32) void',
  gen_sno_get_cut: '(i32) f32',
  gen_sno_get_q: '(i32) f32',
  gen_sno_update: '(i32) void',
  gen_spk_get_cut: '(i32) f32',
  gen_spk_get_q: '(i32) f32',
  gen_spk_update: '(i32) void',
  gen_tanh_get_gain: '(i32) f32',
  gen_tanh_update: '(i32) void',
  gen_tap_get_ms: '(i32) f32',
  gen_tap_get_stepf: '(i32) f32',
  gen_tap_get_targetf: '(i32) f32',
  gen_tap_update: '(i32) void',
  gen_osc_get_hz: '(i32) f32',
  gen_osc_get_lastTrig: '(i32) f32',
  gen_osc_get_trig: '(i32) f32',
  gen_osc_get_offset: '(i32) f32',
  gen_osc_update: '(i32) void',
  gen_sample_get_offset: '(i32) f32',
  gen_sample_get_mask: '(i32) i32',
  gen_sample_get_offsetCurrent: '(i32) f64',
  gen_sample_get_offsetTarget: '(i32) f64',
  gen_sample_get_lastTrig: '(i32) f32',
  gen_sample_get_trig: '(i32) f32',
  gen_sample_update: '(i32) void',
  gen_clamp_get_min: '(i32) f32',
  gen_clamp_get_max: '(i32) f32',
  gen_clamp_get_in: '(i32) i32',
  gen_clamp_audio: '(i32 i32 i32 i32) void',
  gen_clip_get_threshold: '(i32) f32',
  gen_clip_get_in: '(i32) i32',
  gen_clip_audio: '(i32 i32 i32 i32) void',
  gen_comp_get_in: '(i32) i32',
  gen_comp_get_gainReduction: '(i32) f32',
  gen_comp_get_threshold: '(i32) f32',
  gen_comp_get_ratio: '(i32) f32',
  gen_comp_get_attack: '(i32) f32',
  gen_comp_get_release: '(i32) f32',
  gen_comp_get_sidechain: '(i32) i32',
  gen_comp_audio: '(i32 i32 i32 i32) void',
  gen_daverb_get_in: '(i32) i32',
  gen_daverb_get_mask: '(i32) i32',
  gen_daverb_get_index: '(i32) i32',
  gen_daverb_get_lp1: '(i32) f32',
  gen_daverb_get_lp2: '(i32) f32',
  gen_daverb_get_lp3: '(i32) f32',
  gen_daverb_get_excPhase: '(i32) i32',
  gen_daverb_get_predelay: '(i32) i32',
  gen_daverb_get_bw: '(i32) f32',
  gen_daverb_get_pdn: '(i32) f32',
  util_cubic: '(i32 f32 i32) f32',
  gen_daverb_get_fi: '(i32) f32',
  gen_daverb_get_d0: '(i32) i32',
  gen_daverb_get_d1: '(i32) i32',
  gen_daverb_get_si: '(i32) f32',
  gen_daverb_get_d2: '(i32) i32',
  gen_daverb_get_d3: '(i32) i32',
  gen_daverb_get_edn: '(i32) f32',
  engine_get_wavetable: '(i32) i32',
  wavetable_get_mask: '(i32) i32',
  wavetable_readAt: '(i32 i32 i32) f32',
  gen_daverb_get_d4: '(i32) i32',
  gen_daverb_get_dc: '(i32) f32',
  gen_daverb_get_d11: '(i32) i32',
  gen_daverb_get_ft: '(i32) f32',
  gen_daverb_get_d5: '(i32) i32',
  gen_daverb_get_dpn: '(i32) f32',
  gen_daverb_get_st: '(i32) f32',
  gen_daverb_get_d6: '(i32) i32',
  gen_daverb_get_d7: '(i32) i32',
  gen_daverb_get_d8: '(i32) i32',
  gen_daverb_get_d9: '(i32) i32',
  gen_daverb_get_d10: '(i32) i32',
  gen_daverb_audio: '(i32 i32 i32 i32) void',
  gen_dc_get_ceil: '(i32) f32',
  gen_dc_get_sample: '(i32) f32',
  gen_dc_get_in: '(i32) i32',
  gen_dc_audio: '(i32 i32 i32 i32) void',
  gen_dclip_get_in: '(i32) i32',
  gen_dclip_audio: '(i32 i32 i32 i32) void',
  gen_dclipexp_get_factor: '(i32) f32',
  gen_dclipexp_get_in: '(i32) i32',
  gen_dclipexp_audio: '(i32 i32 i32 i32) void',
  gen_dcliplin_get_threshold: '(i32) f32',
  gen_dcliplin_get_factor: '(i32) f32',
  gen_dcliplin_get_in: '(i32) i32',
  gen_dcliplin_audio: '(i32 i32 i32 i32) void',
  gen_delay_get_in: '(i32) i32',
  gen_delay_get_mask: '(i32) i32',
  gen_delay_get_index: '(i32) i32',
  gen_delay_get_fb: '(i32) f32',
  gen_delay_get_floats: '(i32) i32',
  gen_delay_audio: '(i32 i32 i32 i32) void',
  gen_diode_get_A: '(i32) f32',
  gen_diode_get_a: '(i32) f32',
  gen_diode_get_a2: '(i32) f32',
  gen_diode_get_b: '(i32) f32',
  gen_diode_get_b2: '(i32) f32',
  gen_diode_get_c: '(i32) f32',
  gen_diode_get_g: '(i32) f32',
  gen_diode_get_g0: '(i32) f32',
  gen_diode_get_ah: '(i32) f32',
  gen_diode_get_bh: '(i32) f32',
  gen_diode_get_ainv: '(i32) f32',
  gen_diode_get_sat: '(i32) f32',
  gen_diode_get_in: '(i32) i32',
  gen_diode_get_z0: '(i32) f32',
  gen_diode_get_z1: '(i32) f32',
  gen_diode_get_z2: '(i32) f32',
  gen_diode_get_z3: '(i32) f32',
  gen_diode_get_z4: '(i32) f32',
  gen_diode_soft: '(f32 f32) f32',
  gen_diode_audio: '(i32 i32 i32 i32) void',
  gen_lp_get_alpha: '(i32) f32',
  gen_lp_get_beta: '(i32) f32',
  gen_lp_get_sample: '(i32) f32',
  gen_lp_get_in: '(i32) i32',
  gen_lp_audio: '(i32 i32 i32 i32) void',
  gen_moog_get_in: '(i32) i32',
  gen_moog_get__m_amf: '(i32) f32',
  gen_moog_get__m_kacr: '(i32) f32',
  gen_moog_get__m_azt1: '(i32) f32',
  gen_moog_get__m_k2vg: '(i32) f32',
  gen_moog_get__x1: '(i32) f32',
  gen_moog_tanha: '(f32) f32',
  gen_moog_get__m_azt2: '(i32) f32',
  gen_moog_get__m_azt3: '(i32) f32',
  gen_moog_get__az3: '(i32) f32',
  gen_moog_get__m_azt4: '(i32) f32',
  gen_moog_get__az4: '(i32) f32',
  gen_moog_get__m_postGain: '(i32) f32',
  gen_mhp_audio: '(i32 i32 i32 i32) void',
  gen_mlp_audio: '(i32 i32 i32 i32) void',
  gen_svf_get_in: '(i32) i32',
  gen_svf_get_c2: '(i32) f64',
  gen_svf_get_c1: '(i32) f64',
  gen_svf_get_v3: '(i32) f64',
  gen_svf_get_a3: '(i32) f64',
  gen_svf_get_v1: '(i32) f64',
  gen_svf_get_v2: '(i32) f64',
  gen_svf_get_v0: '(i32) f64',
  gen_sap_audio: '(i32 i32 i32 i32) void',
  gen_sbp_audio: '(i32 i32 i32 i32) void',
  gen_shp_audio: '(i32 i32 i32 i32) void',
  gen_slp_audio: '(i32 i32 i32 i32) void',
  gen_sno_audio: '(i32 i32 i32 i32) void',
  gen_spk_audio: '(i32 i32 i32 i32) void',
  gen_tanh_get_gainv: '(i32) v128',
  gen_tanh_get_in: '(i32) i32',
  gen_tanh_audio: '(i32 i32 i32 i32) void',
  gen_tap_get_in: '(i32) i32',
  gen_tap_get_mask: '(i32) i32',
  gen_tap_get_index: '(i32) i32',
  gen_tap_get_floats: '(i32) i32',
  gen_tap_audio: '(i32 i32 i32 i32) void',
  gen_zero_audio: '(i32 i32 i32 i32) void',
  gen_biquad_get_in: '(i32) i32',
  gen_biquad_get_x1: '(i32) f64',
  gen_biquad_get_x2: '(i32) f64',
  gen_biquad_get_y1: '(i32) f64',
  gen_biquad_get_y2: '(i32) f64',
  gen_biquad_audio: '(i32 i32 i32 i32) void',
  gen_osc_get_table: '(i32) i32',
  gen_osc_get_phase: '(i32) i32',
  gen_osc_get_step: '(i32) i32',
  wavetable_read: '(i32 i32 i32 i32 i32 i32 i32) i32',
  gen_osc_audio: '(i32 i32 i32 i32) void',
  gen_sample_get_phase: '(i32) i32',
  gen_sample_get_floats: '(i32) i32',
  util_cubicFrac: '(i32 i32 f32 i32) f32',
  gen_sample_audio: '(i32 i32 i32 i32) void',
  gen_exp_get_table: '(i32) i32',
  gen_noise_get_table: '(i32) i32',
  gen_ramp_get_table: '(i32) i32',
  gen_saw_get_table: '(i32) i32',
  gen_sin_get_table: '(i32) i32',
  gen_sqr_get_table: '(i32) i32',
  gen_tri_get_table: '(i32) i32',
  gen_gen_update_override: '(i32) void',
  gen_gen_audio_override: '(i32 i32 i32 i32) void',
  gen_osc_get_table_override: '(i32) i32'
} as const
